/* RESPONSIBLE TEAM: team-fin-nux */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';

class TutorialsRoute extends Route {
  @service declare router: RouterService;
  @service declare appService: AppService;

  reactEnabled() {
    return true;
  }

  beforeModel() {
    // Always redirect to fin-studio since Fin Studio is now always enabled
    this.router.transitionTo('apps.app.automation.fin-ai-agent.fin-studio');
  }
}

export default ReactRoute(TutorialsRoute);
